export default {
    title: 'Cỏ May Gạo',
    purchaseOrders: 'Phiếu nhập hàng',
    material: 'Nguyên liệu',
    supplier: 'Nhà cung cấp',
    amount: 'Số lượng',
    capacity: 'Khối lượng',
    vehicleNo: 'Biển số',
    container: 'Bồn chứa',
    containers: 'Bồn chứa',
    searchContainers: 'Tìm bồn chứa',
    save: 'Lưu',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    signIn: 'Đăng nhập',
    signOut: 'Đăng xuất',
    remainingAmount: 'Khối lượng còn lại',
    information: 'Thông báo',
    space: 'Trống',
    basicInfo: 'Thông tin cơ bản',
    advancedInfo: 'Thông tin nâng cao',
    language: 'Ngôn ngữ',
    transferOrders: 'Phiếu chạy máy',
    containerMoving: 'Phiếu chuyển kho',
    action: 'Hành động',
    shift: 'Ca làm việc',
    transferFrom: 'Chuyển từ',
    transferTo: 'Chuyển đến',
    having: 'Đang có',
    mosManagement: 'Phiếu sản xuất',
    packing: 'Qui cách đóng gói',
    packingUnit: 'Đơn vị đóng gói',
    saleOrder: 'Phiếu xuất kho',
    saleOrderDetails: 'Nội dung phiếu xuất kho',
    customer: 'Khách hàng',
    addCustomer: 'Tạo mới Khách hàng',
    dashboard: 'Bảng điều khiển',
    field: 'Vùng trồng',
    seekOrigin: 'Truy xuất nguồn gốc',
    close: 'Đóng',
    rememberMe: 'Nhớ mật khẩu',
    check: 'Kiểm tra',
    checkFormula: 'Công thức đấu trộn',
    formulaDetail: 'Chi tiết công thức',
    editFormula: 'Thay đổi công thức',
    addMore: 'Thêm nội dung',
    remove: 'Loại bỏ',
    name: 'Tên',
    noRecords: 'Không có dữ liệu',
    ShiftUsers: 'Ca làm việc',
    documents: 'Tài liệu',
    inventory: 'Tồn kho',
    chooseMaterial: 'Silo BTP và Chất cây',
    chooseContainerOrTree: 'Thành phẩm chờ xuất',
    next: 'Tiếp tục',
    mixFrom: 'Đấu trộn từ',
    suppliment: 'Phụ phẩm',
    supplimentOrder: 'Phiếu nhập phụ phẩm',
    moMaterial: 'Tên thành phẩm',
    finishedProducts: 'Thành phẩm',
    riceAndSuppliment: 'Gạo trắng và PP',
    cardboard_size: 'Thùng các tông',
    cover_amount: 'Số lượng bao bì',
    inventory_covers: 'Tồn kho bao bì',
    transferCovers: 'Phiếu nhập bao bì',
    inventoryPlace: 'Kho',
    cover: 'Bao bì',
    coverCardBoard: 'Thùng các tông',
    covers: 'Bao bì',
    lo: 'Lô',
    size: 'Kích thước',
    miss: 'Hao hụt',
    totalMiss: 'Tổng khối lượng hao hụt',
    addNewSaleOrder: 'Thêm phiếu xuất kho',
    listofSo: 'Danh sách phiếu xuất kho',
    employee: 'Nhân viên',
    addSupplier: 'Tạo mới nhà cung cấp',
    inputSupplierName: 'Nhập tên nhà cung cấp',
    inputCustomerName: 'Nhập tên khách hàng',
    addCommonSuppliment: 'Nhập phụ phẩm chung',
    processing: 'Đang xử lý...',
    mocode: 'Số lô',
    product: 'Hàng hoá',
    price: 'Đơn giá',
    soVehicle: 'Phương tiện',
    listOrders: 'Đơn hàng',
    style: 'Quy cách',
    expectedExport: 'Dự kiến xuất',
    retailCustomer: 'Khách hàng bán lẻ',
    changeview: 'Thay đổi vai trò',
    whoyouare: 'Vai trò của bạn là gì?',
    fillCurrentAmount: 'Nhập số tồn hiện tại',
    accordingActualFigures: 'Theo số liệu thực tế',
    lineColor: 'Màu chỉ',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    exportedAt: 'Xuất kho ngày',
    socode: 'Mã phiếu bán hàng',
    viewMore: 'Xem thêm',
    doesNotExport: 'Chưa xuất kho',
    totalValue: 'Tổng giá trị',
    total_liabilities: 'Tổng công nợ',
    fullname: 'Tên',
    address: 'Địa chỉ',
    shipping_unit: 'ĐV vận chuyển',
    samecont: 'Cùng chuyến xe',
    notes: 'Ghi chú',
    exportReason: 'Lý do xuất kho',
    recipientName: 'Người nhận hàng',
    company_name: 'Đơn vị',
    vehicleOwner: 'Chủ xe',
    solo: 'Số lô',
    pocode: 'Mã phiếu',
    device: 'Máy',
    bin: 'Bin/Vị trí',
    for_internal: 'Cho nội bộ',
    company: {
        description: 'Cỏ May Automation (CMA) đem đến các giải pháp giúp doanh nghiệp tối ưu hóa chi phí sản xuất và vận hành dựa trên nền tảng tri thức và công nghệ.',
    },
    errors: {
        title: 'Lỗi',
        login: 'Lỗi đăng nhập',
        required: 'Trường này không được để trống',
        requiredAll: 'Vui lòng điền đầy đủ thông tin',
        inputAmount: 'Số lượng còn lại của các bồn chứa không đủ cho số lượng đầu vào',
        outputAmount: 'Số lượng còn lại của bồn chứa không đủ cho số lượng xuất kho',
        inputError: 'Số lượng đầu ra không thể ít hơn số lượng đầu vào',
        requiredCode: 'Vui lòng nhập mã sản xuất',
        greaterZero: 'Số nhập vào phải lớn hơn không',
        requiredSolo: 'Vui lòng nhập số lô',
    },
    success: {
        addPO: 'Thêm phiếu nhập hàng thành công',
        addTO: 'Thêm phiếu chuyển kho thành công',
        addMO: 'Thêm phiếu sản xuất thành công',
        addSO: 'Thêm phiếu xuất kho thành công',
        addSupplier: 'Thêm nhà cung cấp thành công',
        addSuppliment: 'Thêm phụ phẩm thành công',
        addSODetail: 'Thêm Nội dung phiếu xuất kho thành công',
        editShiftUser: 'Cập nhật ca làm việc thành công',
        transferCovers: 'Thêm bao bì thành công',
        addCustomer: 'Thêm khách hàng thành công',
        changeRole: 'Thay đổi vai trò thành công',
        changeCapacity: 'Thay đổi số tồn thành công',
    },
    msg: {
        noFormulaDetails: 'Không tìm thấy công thức cho loại nguyên liệu này',
        confirmInputSuppliment: 'Bạn có muốn thêm phụ phẩm cho phiếu chuyển kho',
    },
}
